import React, { Component } from 'react'
import "./Product_imgs.css";
import Product_thumbnails from '../Product_thumbnails/Product_thumbnails';

export default class Product_imgs extends Component {
  render() {
    const {fromUpsell, specific_product_id, ProductData, shoppingMoreThanOne, selectedVariants} = this.props

    let img_src = null;
    if(selectedVariants.length > 0){
      img_src = shoppingMoreThanOne === true || selectedVariants[0].img_src === undefined || selectedVariants[0].img_src === null || selectedVariants[0].img_src === ""? ProductData.comodin_main_img_src.file_src : selectedVariants[0].img_src
    } else {
      img_src = ProductData.comodin_main_img_src.file_src
    }

    let aux_additional_comodin_imgs_src = []
    ProductData.additional_comodin_imgs_src.map(img=>{
      aux_additional_comodin_imgs_src.push(img.file_src)
    })

    return (
        <div className='Product_imgs'>
          {fromUpsell===true?
            <div className='Product_img'>
                <img src={img_src} alt=""/>
            </div>
          :
            <Product_thumbnails specific_product_id={specific_product_id} mainImage={img_src} images={aux_additional_comodin_imgs_src}/>
          }
        </div>
    )
  }
}